import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ParkingSquare, Menu, X } from "lucide-react";
import { useState } from "react";

export default function Header() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const dashHref = user?.role === "admin" ? "/admin" : user?.role === "host" ? "/host" : "/account/bookings";

  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-slate-200" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <span className="w-9 h-9 rounded-xl bg-[var(--fpn-navy)] text-white grid place-items-center">
            <ParkingSquare size={18} strokeWidth={2.25} />
          </span>
          <span className="font-display text-xl font-bold text-[var(--fpn-navy)]">Park<span className="text-[var(--fpn-amber-2)]">pot</span></span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-slate-700">
          <Link to="/airport-parking" className="hover:text-[var(--fpn-navy)]" data-testid="nav-airport-parking">Airport Parking</Link>
          <Link to="/host" className="hover:text-[var(--fpn-navy)]" data-testid="nav-list-your-space">List Your Space</Link>
          <Link to="/legal" className="hover:text-[var(--fpn-navy)]" data-testid="nav-help">Help</Link>
          {user ? (
            <>
              <Link to={dashHref} className="hover:text-[var(--fpn-navy)]" data-testid="nav-dashboard">
                {user.role === "admin" ? "Admin" : user.role === "host" ? "Host" : "My Bookings"}
              </Link>
              <button onClick={() => { logout(); nav("/"); }} className="hover:text-[var(--fpn-navy)]" data-testid="nav-logout">Sign out</button>
            </>
          ) : (
            <Link to="/login" className="hover:text-[var(--fpn-navy)]" data-testid="nav-signin">Sign In</Link>
          )}
        </nav>

        <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Toggle menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 px-5 py-4 flex flex-col gap-4 text-sm bg-white" data-testid="nav-mobile-panel">
          <Link to="/" onClick={() => setOpen(false)}>Airport Parking</Link>
          <Link to="/host" onClick={() => setOpen(false)}>List Your Space</Link>
          {user ? (
            <>
              <Link to={dashHref} onClick={() => setOpen(false)}>{user.role === "admin" ? "Admin" : user.role === "host" ? "Host" : "My Bookings"}</Link>
              <button onClick={() => { logout(); setOpen(false); nav("/"); }}>Sign out</button>
            </>
          ) : (
            <Link to="/login" onClick={() => setOpen(false)}>Sign In</Link>
          )}
        </div>
      )}
    </header>
  );
}
